import React, {memo, useCallback, useMemo, useState} from 'react';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {SettingInputComponent} from '../../../../components/Settings/SettingInputComponent';
import {useRPC} from '../../../../hooks/rpc';
import {useMessage} from '../../../../hooks/message';
import {useHistory} from 'react-router-dom';

import './index.scss';
import {useLocalization} from "../../../../hooks/localization";

const BACK_URL = '/settings';

export const SetDateTimeScreen = memo(function SetDateTimeScreen() {
    const {t} = useLocalization();
    const [rpc] = useRPC();
    const {success, failure} = useMessage();
    const history = useHistory();

    const [pickedDateString, setPickedDateString] = useState('');
    const [pickedTimeString, setPickedTimeString] = useState('');

    const onBackPressed = useCallback(() => {
        history.push(BACK_URL);
    }, [history]);

    const onSavePressed = useCallback(() => {
        if (pickedDateString === '') {
            failure(t('pls_enter_a_valid_date'));

            return;
        }

        const pickedDate = new Date(pickedDateString);
        if (!(pickedDate instanceof Date) || isNaN(pickedDate as unknown as number)) {
            failure(t('pls_enter_a_valid_date'));

            return;
        }

        if (pickedTimeString === '') {
            failure(t('pls_enter_a_valid_time'));

            return;
        }

        const offset = -pickedDate.getTimezoneOffset();
        const dateUTC = pickedDate.getTime() / 1000 - (offset * 60);
        const [pickedHourString, pickedMinuteString] = pickedTimeString.split(':');
        const calculatedTime = Number(pickedHourString) * 60 * 60 + Number(pickedMinuteString) * 60;
        rpc.updateTimeAndWeather(dateUTC + calculatedTime, offset)
            .then(() => {
                success(t('successfully_saved'));
                onBackPressed();
            }).catch(failure);
    }, [t, pickedDateString, pickedTimeString, rpc, onBackPressed, failure, success]);

    const buttons = useMemo(() => [
        {
            text: t('save'),
            className: 'green',
            onClick: onSavePressed,
        },
        {
            text: t('cancel'),
            className: 'red',
            url: BACK_URL,
        },
    ], [t, onSavePressed]);

    return (
        <PasswordContainer requiredRole='user' isFullscreen={true}>
            <SettingsPageContainer
                className='service-edit'
                buttons={buttons}
                backUrl={BACK_URL}
                title={t('set_date_and_time')}>
                <div className='content-divider'>
                    <div className='content-wrapper'>
                        <SettingInputComponent
                            placeholder={t('set_date')}
                            label={t('date')}
                            value={pickedDateString}
                            setValue={setPickedDateString}
                            setActiveInput={null}
                            type='date'/>
                        <SettingInputComponent
                            placeholder={t('set_time')}
                            label={t('time')}
                            value={pickedTimeString}
                            setValue={setPickedTimeString}
                            setActiveInput={null}
                            type='time'/>
                    </div>
                    <div className='content-wrapper'>
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
